<template>
    <div class="cyl">
        <div class="banner">
            <img class="banner_img" src="../../static/img/cyl_banner.png" alt="">
            <div class="yc_1" id="cyl">1</div>
        </div>
        <div class="cyl_1">
            <div class="content">
                <div class="content_nav w1200" :class="{ active_nav : nav }">
                    <router-link to="/cyl?page=2#cyl">
                        <span @click="wybs = 0" :class="{hong: wybs === 0 }"> 产业链  </span>
                    </router-link>
                    <router-link to="/cyl?page=2#xhwb">
                        <span @click="wybs = 1" :class="{hong: wybs === 1 }">协和万邦</span>
                    </router-link>
                    <router-link to="/cyl?page=2#fsps">
                        <span @click="wybs = 2" :class="{hong: wybs === 2 }">方胜磐石</span>
                    </router-link>
                </div>
            </div>
            <div class="fesc_1">
                <div class="fesc_title w1200">
                    <h2>产业链</h2>
                    <h4>ABOUT INDUSTRY CHAIN</h4>
                </div>
                <div class="pic w1200">
                    <div class="cyl_text">
                        <p class="sj_text">以科技创新为核心，引领新时代的互联网保险发展。</p>
                        <p class="sj_text">用科技的手段帮助各个保险公司在财险，团险，个脸领域进行，成本调优，服务提升，客户体验感不断增强。</p>
                        <p class="sj_text">用科技能力驱动保险中介业务的发展，在客户基本保障的基础上，帮其在健康，弹性福利等领域持续享受高质量的增值服务。</p>
                    <div class="yc_2" id="xhwb">1</div>
                    </div>
                    <img class="kjcx" src="../../static/img/cyl_kjcx.png" alt="">
                </div>
                <div class="fesc_2">
                    <div class="fesc_title1 w1200">
                        <h2>协和万邦</h2>
                        <h4>ABOUT XIE HE WAN BANG</h4>
                    </div>
                </div>
                <div class="fesc_text">
                    <p class="tt"><img src="../../static/img/cyl_xh_gsjs.png" alt=""></p>
                    <p class="js sj_text">协和万邦保险经纪有限公司成立于2008年，公司注册资金5000万。经过七年稳健、创新发展，目前正结合互联网思维，采用O2O模式，倾力打造以“飞猪保险”、“停有钱”项目为核心的金融服务平台，是一家具备全国代理资质的保险中介机构。</p>
                    <ul class="pic_xh">
                        <li class="js_img" v-for="(item,i) in xhimg" :key="i">
                            <img :src="item.img" alt="">
                            <div class="bj_img">
                                <img src="../../static/img/zz.png" alt="">
                                <div class="text">
                                    <span></span>
                                    <h4>{{item.bt}}</h4>
                                    <div class="wz">
                                        <p>{{item.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="js_img1">
                            <img src="../../static/img/xh_qyjs.png" alt="">
                            <div class="text">
                                <span></span>
                                <h4>企业精神</h4>
                                <div class="wz">
                                    <p>诚信守法、团结进取、追求卓越、服务领先、创造价值、简单务实、不怕困难、积极进取、回馈社会、报效国家。</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="yc" id="fsps">1</div>

                </div>
                <div class="fesc_2">
                    <div class="fesc_title1 w1200">
                        <h2>方胜磐石</h2>
                        <h4>ABOUT FANG SHENG PAN SHI</h4>
                    </div>
                </div>
                <div class="fesc_text w1200">
                    <p class="tt"><img src="../../static/img/cyl_xh_gsjs.png" alt=""></p>
                    <p class="js sj_text">方胜馨石保险经纪有限公司是经中国保监会批准设立的一家全国性保险中介服务企业，2003年成立于北京，注册资本金5000万。两岸三地一线品牌四大股东强势重组，优势互补，横跨品牌价值、客户资源、营销技术、客户服务、IT科技等重要领域，为FESCO ROCK个险发展奠定基础！
                    </p>
                    <ul class="pic_xh">
                        <li class="js_img" v-for="(item,i) in fsimg" :key="i">
                            <img :src="item.img" alt="">
                            <div class="bj_img">
                                <img src="../../static/img/zz.png" alt="">
                                <div class="text">
                                    <span></span>
                                    <h4>{{item.bt}}</h4>
                                    <div class="wz">
                                        <p>{{item.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="js_img1">
                            <img src="../../static/img/xh_qyjs.png" alt="">
                            <div class="text">
                                <span></span>
                                <h4>经营原则</h4>
                                <div class="wz">
                                    <p>以财务稳健为基础，以诚信专业为核心，以提升员工素质为目标，以善尽社会公益为责任。用爱与关怀，建立-一个投资于人，相互信任，稳健经营，追求卓越的运营模式，创造真诚的保险服务，成为华人地区的领导品牌。</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
  name: 'Gyl',
  data () {
    return {
      nav: false,
      wybs: null,
      xhimg: [
        {
          img: require('../../static/img/yl_zct.png'),
          bt: '协和万邦的由来',
          text: '协和万邦的观念第一次以下列的形式被表述出来："日若稽古，帝尧日放勋，钦明文思安安，允恭克让，光被四表，格于上下。克明俊德，以亲九族。九族既睦，平章百姓，百姓昭明，协和万邦，黎民于变时雍。"（《尚书·尧典》），这就是"协和万邦"。'

        },
        {
          img: require('../../static/img/yj.png'),
          bt: '愿景',
          text: '成为全球领先的保险经纪公司'
        },
        {
          img: require('../../static/img/sm.png'),
          bt: '使命',
          text: '五大责任： 第一：对公司负责；第二：对股东负责；第三：对客户负责；第四：对员工负责；第五：对社会负责。'
        }
      ],
      fsimg: [
        {
          img: require('../../static/img/fs_yj.png'),
          bt: '愿景',
          text: '致力于打造一个提供客户全方位最贴心的保险咨询和保障服务,提供高端客户全面优质的保险理财产品服务,提供客户最好的健康保险保障服务,提供专业人才行业内最好的成长机遇,引领行业发展的全国性、全方位、专业型金融中介集团',
          id: 0

        },
        {
          img: require('../../static/img/fs_hxjz.png'),
          bt: '核心价值',
          text: '诚信、专业、真情、合作、责任',
          id: 1
        },
        {
          img: require('../../static/img/fs_js.png'),
          bt: '三Q精神',
          text: '品质、数量、专业资格',
          id: 2
        }
      ]
    }
  },
  mounted () {
      
    if(this.isMobile()) {
          this.$router.push({ path: "/industrial" });
        } else {
          this.$router.push({ path: "/cyl?page=2" });
        }
    let navH = 540
    window.onscroll = _ => {
      var SH = document.body.scrollTop || document.documentElement.scrollTop
      if (SH >= (navH - 20)) {
        this.nav = true
      } else {
        this.nav = false
      }
    }
   
  },
  methods: {
    skip (url) {
      location.href = url
    },
      isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
    .yc_1 {
        position: relative;
        bottom: .3rem;
        opacity: 0;
    }
}
.cyl_1 {
    background: #014fa2;
    width: 100%;
    max-width: 19.2rem;
    margin: 0 auto;
    .content {
        position: relative;
        height: auto;
        color: #fffff6;
        .content_nav {
            height: 1.15rem;
            color: #5f5f5f;
            line-height: 1.15rem;
            background-color: #eee;
            font-size: .22rem;
            display: flex;
            justify-content: space-around;
            position: absolute;
            left: 50%;
            z-index: 10;
            transform: translateX(-50%) translateY(-0.45rem);
            span{
                color:#5f5f5f;
                width: .88rem;
                text-align: center;
                display: inline-block;
            }
        }
        .active_nav {
            position: fixed;
            top: .1rem;
            left: 50%;
            color: red;
            transform: translateX(-50%) translateY(0);
            z-index: 11;
        }
        >.content_nav .hong{
            color: red;
        }
    }
    .fesc_1 {
        padding-top: .5rem;
        color: #f1f7f5;
        .fesc_title {
            height: auto;
            font-size: .24rem;
            h2 {
                font-size: .34rem;
                line-height: .55rem;
                text-align: center;
                padding-top: .5rem;
            }
            h4 {
                font-size: .2rem;
                line-height: .55rem;
                text-align: center;
            }
        }
        .pic {
            padding: .35rem 0;
            height: 4rem;
            color: #787878;
            font-size: .24rem;
            .cyl_text {
                width: 7.15rem;
                height: 3.65rem;
                float: left;
                box-sizing: border-box;
                background-color: #f2f2f2;
                padding: .3rem .9rem .3rem .25rem;
                position: relative;
                p {
                    line-height: .34rem;
                    margin: .2rem 0;
                }
                .yc_2 {
                position: absolute;
                margin-top: -0.9rem;
                opacity: 0;
            }
            }
            .kjcx {
                display: block;
                width: 4.81rem;
                height: 3.65rem;
                float: left;
            }
        }
        .fesc_2 {
            background-color: #de101d;
            padding-top: .3rem;
            color: #f1f7f5;
            .fesc_title1 {
                height: auto;
                font-size: .24rem;
                h2 {
                    font-size: .34rem;
                    line-height: .55rem;
                    text-align: center;
                }
                h4 {
                    font-size: .2rem;
                    line-height: .55rem;
                    text-align: center;
                }
            }
        }
        .fesc_text {
            width: 12.10rem;
            margin: 0 auto;
            p {
                line-height: .28rem;
                font-size: .22rem;
                margin-top: .15rem;
                cursor: pointer;
            }
            .tt {
                margin-top: .38rem;
            }
            .js {
                margin: .6rem 0;
            }
            .pic_xh {
                width: 100%;
                max-width: 19.2rem;
                overflow: hidden;
                margin: 0 auto;
                padding-bottom: .3rem;
                display: flex;
                flex-wrap: wrap;
                .js_img {
                    cursor: pointer;
                    width: 49.4%;
                    max-width: 9.50rem;
                    height: auto;
                    float: left;
                    position: relative;
                    overflow: hidden;
                    padding-bottom: .2rem;
                    img {
                        width: 100%;
                    }
                    .bj_img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: -100%;
                        transition: all 0.15s;
                        top: -0px;
                        z-index: 1;
                        .text {
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            font-size: .24rem;
                            padding: 1rem .3rem .3rem .3rem;
                            box-sizing: border-box;
                            span {
                                display: block;
                                width: .75rem;
                                height: 8px;
                                line-height: .4rem;
                                background-color: #fff;
                            }
                            h4 {
                                padding: .3rem 0;
                                font-size: .26rem;
                            }
                        }
                    }
                }
                .js_img:hover > .bj_img {
                    left: 0;
                }
                .js_img:nth-child(even) {
                    margin-left: .13rem;
                    .bj_img {
                        transition: all 0.15s;
                    }
                }
                .js_img1 {
                    cursor: pointer;
                    width: 49.4%;
                    max-width: 9.50rem;
                    height: auto;
                    float: left;
                    margin-left: .13rem;
                    padding-bottom: .2rem;
                    position: relative;
                    img {
                        width: 100%;
                    }
                    .text {
                        position: absolute;
                        top: 0;
                        z-index: 1;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        font-size: .24rem;
                        padding: 1rem .3rem .3rem .3rem;
                        box-sizing: border-box;
                        span {
                            display: block;
                            width: .75rem;
                            height: 8px;
                            line-height: .4rem;
                            background-color: #fff;
                        }
                        h4 {
                            padding: .3rem 0;
                            font-size: .26rem;
                        }
                    }
                }
            }
        }
    }
    .yc {
        position: relative;
        bottom: 1.3rem;
        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cyl.vue